export interface UploadVolumeNegotiation {
  [key: string]: any;
  "Código Pedido Volume": string;
  "Código Fornecedor": string;
  "Descrição Fornecedor": string;
  "Código Destino": string;
  "Descrição Destino": string;
  "Código Material": string;
  "Descrição Material": string;
  "Data de Coleta": string;
  "Data de Entrega": string;
  "Quantidade": string;
  "Justificativa": string;
  "Observação": string;
  "Recusar Total": string;
  "Aceite Total": string;
}

export const UploadVolumeNegotiationPtBrCSVEmpty = {
  "Código Pedido Volume": "",
  "Código Fornecedor": "",
  "Descrição Fornecedor": "",
  "Código Destino": "",
  "Descrição Destino": "",
  "Código Material": "",
  "Descrição Material": "",
  "Data de Coleta": "",
  "Data de Entrega": "",
  "Quantidade": "",
  "Justificativa": "",
  "Observação": "",
  "Recusar Total": "",
  "Aceite Total": "",
};

export const UploadVolumeNegotiationEsCSVEmpty = {
  "Código de Pedido Volumen": "",
  "Código de Proveedor": "",
  "Descripción Proveedor": "",
  "Código de Destino": "",
  "Descripción Destino": "",
  "Código Material": "",
  "Descripción Material": "",
  "Fecha de Despacho": "",
  "Fecha de Entrega": "",
  "Cantidad": "",
  "Justificación": "",
  "Observación": "",
  "Total Rechazo": "",
  "Aceptación Plena": "",
};

export const UploadVolumeNegotiationEnCSVEmpty = {
  "Order Volume Code": "",
  "Supplier Code": "",
  "Supplier Description": "",
  "Destination Code": "",
  "Description Destination": "",
  "Material Code": "",
  "Material Description": "",
  "Pick Up Date": "",
  "Delivery Date": "",
  "Amount": "",
  "Justification": "",
  "Note": "",
  "Total Refusal": "",
  "Full Acceptance": "",
};

export const UploadVolumeNegotiationRequiredFieldsPtBr = [
  "Código Fornecedor",
  "Data de Coleta",
  "Quantidade"
];

export const UploadVolumeNegotiationRequiredFieldsEs = [
  "Código de Proveedor",
  "Fecha de Despacho",
  "Cantidad"
];

export const UploadVolumeNegotiationRequiredFieldsEn = [
  "Supplier Code",
  "Pick Up Date",
  "Amount"
];

export interface IUploadVolumeNegotiation {
  line: number;
  volumeOrderCode: string;
  supplierCode: string;
  supplierDescription: string;
  center: string;
  centerDescription: string;
  materialNumber: string;
  materialDescription: string;
  pickupDate: string;
  deliveryDate: string;
  quantity: number;
  typeJustificationManualSuggestion: number;
  comments: string;
  acceptTotal: string;
  refuse: string;
}